module.exports = __webpack_public_path__ + "img/Return-disabled.3013ffad.svg";